import { useCallback, useEffect, useState } from 'react';

import { openDialog } from 'src/services/jira';

import { trackEvent } from 'src/lib/analytics';
import integration from 'src/lib/api/integration';

const reloads = [];
const reloadAll = () => reloads.forEach(item => item());

export const useMappedUsers = () => {
  const [{ mappedUsers, total, loading, error, filter, reloadId }, setState] = useState({
    mappedUsers: [],
    total: 0,
    loading: true,
    error: null,
    filter: '',
    reloadId: 1,
  });

  const onFilterChange = useCallback((filter) => {
    setState(s => ({ ...s, filter, reloadId: s.reloadId + 1 }));
  }, []);

  // increment reloadId on reloadAll call
  useEffect(() => {
    const incrementer = () => setState(s => ({ ...s, reloadId: s.reloadId + 1 }));
    reloads.push(incrementer);
    return () => reloads.splice(reloads.indexOf(incrementer), 1);
  });

  // load items
  useEffect(() => {
    let mounted = true;
    setState(s => ({ ...s, loading: true }));
    integration
      .getMappedUsers({ query: filter })
      .then(({ user_mappings, total }) => {
        if (!mounted) return;
        setState(old => ({
          ...old,
          mappedUsers: user_mappings,
          total,
          loading: false,
          error: null,
        }));
      })
      .catch(e => {
        if (!mounted) return;
        setState(old => ({
          ...old,
          loading: false,
          error: e,
        }));
      });

    return () => { mounted = false; };
  }, [filter, reloadId]);

  return {
    mappedUsers,
    total,
    loading,
    error,
    filter,
    onFilterChange,
  };
};

export const openMapUsersDialog = () => {
  trackEvent('settings_usermappings_linkedaccounts', { label: 'link_users' });
  openDialog('/integration-jira-ui/settings/modal/link_users', {
    width: '60vw',
    minHeight: 400,
    onClose: () => {
      reloadAll();
    }
  });
};

export const openRemoveUsersMappingDialog = (id) => {
  openDialog(`/integration-jira-ui/settings/modal/remove_users_mapping?userMappingId=${id}`, {
    width: '40vw',
    minHeight: 400,
    onClose: () => {
      reloadAll();
    }
  });
};
